export default __webpack_public_path__ + "static/media/cliente12_color.67addaaa.png";